import { useEffect, useRef, useState } from "react";
import { MaterialIcon } from "@/components/MaterialIcon";
import { useWindowWidth, resolveResponsive } from "@/lib/useBreakpoint";

export const Carousel = ({ items, render, perView = 3, gap = 20, thumbAspect = "315 / 185", testId }) => {
  const ref = useRef(null);
  const width = useWindowWidth();
  const per = resolveResponsive(perView, width) || 1;
  const [atEnd, setAtEnd] = useState(false);
  const [hasMore, setHasMore] = useState(items.length > per);

  useEffect(() => {
    setHasMore(items.length > per);
    setAtEnd(false);
  }, [items.length, per]);

  const next = () => {
    const el = ref.current;
    if (!el) return;
    el.scrollTo({ left: el.scrollLeft + el.clientWidth + gap, behavior: "smooth" });
  };

  const cardWidth = `calc((100% - ${gap * (Math.ceil(per) - 1)}px) / ${per})`;

  return (
    <div className="relative" data-testid={testId}>
      <div
        ref={ref}
        onScroll={(e) => setAtEnd(e.target.scrollLeft + e.target.clientWidth >= e.target.scrollWidth - 4)}
        className="flex overflow-x-auto no-scrollbar snap-x snap-mandatory"
        style={{ gap }}
      >
        {items.map((item, i) => (
          <div key={item.id || i} className="flex-none snap-start" style={{ width: cardWidth }}>
            {render(item, i)}
          </div>
        ))}
      </div>
      {hasMore && !atEnd && (
        <div className="absolute top-0 right-0 pointer-events-none flex items-center" style={{ width: cardWidth, aspectRatio: thumbAspect }}>
          <button
            type="button"
            onClick={next}
            className="pointer-events-auto absolute -right-3 flex items-center justify-center text-black hover:scale-110 transition-transform duration-200"
            aria-label="Next"
            data-testid="carousel-next-button"
          >
            <span className="absolute w-[40px] h-[40px] rounded-full bg-white" aria-hidden="true" />
            <MaterialIcon name="arrow_circle_right" filled size={54} className="relative" />
          </button>
        </div>
      )}
    </div>
  );
};
